import { Customer, InvitationCustomer } from '@algoan/dashboard/model';

export const convertCustomerToInvitationCustomer = (customer: Customer): InvitationCustomer | undefined => {
  if (!customer.personalDetails) {
    return undefined;
  }

  return {
    customIdentifier: customer.customIdentifier,
    customerId: customer.id,
    sessionId: '',
    personalDetails: {
      identity: {
        firstName: customer.personalDetails?.identity?.firstName as string,
        lastName: customer.personalDetails?.identity?.lastName as string,
      },
      contact: {
        email: customer.personalDetails?.contact?.email as string,
        phoneNumber: customer.personalDetails?.contact?.phoneNumber as string,
      },
    },
    ...(customer.personalDetailsOfCoBorrower && {
      personalDetailsOfCoBorrower: {
        identity: {
          firstName: customer.personalDetailsOfCoBorrower?.identity?.firstName as string,
          lastName: customer.personalDetailsOfCoBorrower?.identity?.lastName as string,
        },
        contact: {
          email: customer.personalDetailsOfCoBorrower?.contact?.email as string,
          phoneNumber: customer.personalDetailsOfCoBorrower?.contact?.phoneNumber as string,
        },
      },
    }),
  };
};
